/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
   * Contador del carrito al volver atras.
   *
   * Al navegar hacia atras el navegador no vuelve a evaluar Liquid: o restaura el
   * documento desde el bfcache, o sirve el HTML desde su propia cache. En los dos
   * casos <cart-count> se queda con el valor que tenia al salir de la pagina.
   * En el caso del bfcache 'load' y 'DOMContentLoaded' no se disparan, por eso el
   * gancho es 'pageshow'. La condicion cubre los dos caminos: 'persisted' para el
   * bfcache y el tipo de navegacion para la vuelta servida desde cache.
   *
   * 'theme:cart:refresh' es el hook del theme (ver assets/theme.js): encadena a
   * getCart(), que pide /cart?section_id=api-cart-items y llama a build(). Ahi se
   * emite 'theme:cart:change' con el conteo, que es lo que consume <cart-count>,
   * respetando su data-limit. De paso se rearman los items del drawer, el subtotal
   * y la barra de envio gratis, asi que quien vuelve atras y abre el carrito
   * tampoco ve la lista vieja.
   */
  window.addEventListener('pageshow', function (event) {
    var navigation = performance.getEntriesByType('navigation')[0];
    var isBackForward = Boolean(navigation) && navigation.type === 'back_forward';

    if (!event.persisted && !isBackForward) return;

    /*
     * build() termina anunciando 'theme:product:added' y el drawer escucha ese
     * evento para abrirse solo. Al volver atras no se agrego nada, asi que ese
     * anuncio se descarta una unica vez. El listener va en captura sobre window,
     * que es el primer tramo del recorrido del evento, antes que los listeners
     * de document. El temporizador es la red de seguridad: si getCart() falla,
     * build() nunca corre y sin el se quedaria tragando el anuncio de la
     * siguiente compra real, dejando el drawer sin abrirse.
     */
    var swallowAdded = function (addedEvent) {
      addedEvent.stopImmediatePropagation();
      window.removeEventListener('theme:product:added', swallowAdded, true);
    };

    window.addEventListener('theme:product:added', swallowAdded, true);
    setTimeout(function () {
      window.removeEventListener('theme:product:added', swallowAdded, true);
    }, 8000);

    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
